package com.zi.support.web

import com.zi.support.shared.GpsLocations
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event

/** More > Locations: the shared map page (GpsLocations.PAGE) in an iframe; this side answers its Firestore questions. */
internal object LocationsScreen {
    fun render() {
        element("content")?.innerHTML = """
          $MORE_BACK
          <iframe id="locations-frame" class="locations-frame locations-full" title="Locations map"></iframe>
        """.trimIndent()
        bindMoreBack()
        val frame: dynamic = element("locations-frame")
        frame.onload = { frame.contentWindow.setTheme(if (document.documentElement?.getAttribute("data-theme") == "dark") "dark" else "light") }
        showPage(frame, GpsLocations.PAGE)
        lateinit var listener: (Event) -> Unit
        listener = fn@{ event ->
            // Leaving the screen replaces the page: once the frame is gone, stop listening.
            val current: dynamic = element("locations-frame") ?: run { window.removeEventListener("message", listener); return@fn }
            val data: dynamic = event.asDynamic().data
            if (event.asDynamic().source != current.contentWindow || data == null || jsTypeOf(data.locations) != "string") return@fn
            answer(current, JSON.parse(data.locations as String))
        }
        window.addEventListener("message", listener)
    }

    private fun answer(frame: dynamic, request: dynamic) {
        if (request.type == "call") { frame.contentWindow.locationsReply(request.id, js("[]"), null); CallScreen.call(request.deviceId as String, request.name as String); return }
        val fs = FirebaseGateway.firestore
        val queries: Array<dynamic> = if (request.type == "devices") GpsLocations.devicePaths.map { FirebaseGateway.getCollection(it) }.toTypedArray()
        else arrayOf(FirebaseGateway.getCollection("${request.path}/points", arrayOf(
            fs.where("recordedAt", ">=", FirebaseGateway.timestampFromMillis(request.from as Double)),
            fs.where("recordedAt", "<", FirebaseGateway.timestampFromMillis(request.to as Double)),
            fs.orderBy("recordedAt"))))
        promise(js("Promise").all(queries), { snapshots ->
            val rows = js("[]")
            for (snapshot in snapshots as Array<dynamic>) for (doc in snapshot.docs as Array<dynamic>) {
                val fields: dynamic = doc.data()
                val row: dynamic = json("path" to doc.ref.path)
                for (key in js("Object.keys")(fields) as Array<String>) {
                    val value: dynamic = fields[key]
                    row[key] = if (value != null && jsTypeOf(value.toMillis) == "function") value.toMillis() else value
                }
                rows.push(row)
            }
            frame.contentWindow.locationsReply(request.id, rows, null)
        }, { message -> frame.contentWindow.locationsReply(request.id, null, message) })
    }
}
